import React from 'react'
import Image from 'next/image'


function ItemImage({ item }) {
    return (
        (item && item.media && item.media[0] && item.media[0].original_url) ? (
            <Image
                src={item.media[0].original_url}
                alt={item.name}
                width={process.env.NEXT_PUBLIC_LARGE_IMAGE_WIDTH}
                height={process.env.NEXT_PUBLIC_LARGE_IMAGE_HEIGHT}
                className="bg-white mb-4 inline-block object-contain"
            />

        ) : (
            <Image
                src={process.env.NEXT_PUBLIC_COMING_SOON_IMAGE}
                alt={item.name}
                width={process.env.NEXT_PUBLIC_LARGE_IMAGE_WIDTH}
                height={process.env.NEXT_PUBLIC_LARGE_IMAGE_HEIGHT}
                className="bg-white mb-4 inline-block object-contain"
            />
        )
    );
}

export default ItemImage;

